import JsonApiObject from '@/_models/JsonApi'

import Log from '@/views/Log/models/log'

import AuthorizationLog from '@/views/Authorization/dialogs/authorizationLog/authorizationLog.vue'

export default class Authorization extends JsonApiObject {
    static async showAuthorizationLog() {
        await JsonApiObject.openDialog(AuthorizationLog, {})
    }

    static async getAuthorizationLog(projectId: string, timeStamp: any) {
        let data = {
            'filter[activityLogEntityId]': projectId,
            'filter[activityLogNumber]': ['11', '12'],
            'filter[time][lt]': timeStamp,
        }

        let res = await Log.getLog(data)

        return res
    }
}
